export default "__VITE_ASSET__BlYVdqLT__"